import { ComponentRadius, FourSideStylingEntity, TextAlignment } from 'app/campaign/widgets.model';

export interface BrandVariable {
  id?: number;
  isAutomaticallyGenerated?: boolean;
  headline: BrandVariableHeadline;
  text: BrandVariableText;
  button: BrandVariableButton;
  input: BrandVariableInput;
  label: BrandVariableLabel;
  canvas: BrandVariableCanvas;
}

export interface BrandVariableHeadline extends BrandVariableTextProperties {}

export interface BrandVariableText extends BrandVariableTextProperties {}

export interface BrandVariableButton extends BrandVariableTextProperties {
  radius: ComponentRadius;
  backgroundColor: string;
  border: BrandVariableBorder;
  padding: FourSideStylingEntity;
  margin: FourSideStylingEntity;
  height: string;
  alignment: TextAlignment;
}

interface BrandVariableInput extends BrandVariableTextProperties {
  radius: ComponentRadius;
  backgroundColor: string;
  border: BrandVariableBorder;
  padding: FourSideStylingEntity;
  margin: FourSideStylingEntity;
  height: string;
  alignment?: TextAlignment;
}

interface BrandVariableLabel extends BrandVariableTextProperties {}

interface BrandVariableCanvas {
  backgroundColor: string;
  // backgroundImage: string;
  closeButtonColor: string;
  radius: ComponentRadius;
}

export interface BrandVariableTextProperties {
  color: string;
  font?: string;
  fontSize?: string;
  lineHeight?: string;
  fontWeight?: number;
  letterSpacing?: string;
  textProperties?: {
    font: string;
    fontSize: string;
    lineHeight: string;
    fontWeight: number;
    letterSpacing: string;
  };
}

export interface BrandVariableBorder {
  color: string;
  width: string;
}

export enum BrandVarEntity {
  Color = 'color',
  Font = 'font',
  FontSize = 'fontSize',
  LineHeight = 'lineHeight',
  FontWeight = 'fontWeight',
  LetterSpacing = 'letterSpacing',
  Headline = 'headline',
  Text = 'text',
  Button = 'button',
  Radius = 'radius',
  BackgroundColor = 'backgroundColor',
  CloseButtonColor = 'closeButtonColor',
  Border = 'border',
  Width = 'width',
}
